// Formatting for the history page. Publish dates arrive as ISO timestamps; the
// archive names a list by its calendar day in the reader's own timezone.

export function fmtPublishDate(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

// Compact form for chart axes and chips: "Sep 27"
export function fmtShortDate(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}

export function fmtWeeks(n: number): string {
  return `${n} ${n === 1 ? 'week' : 'weeks'}`
}

// "?v=" from the URL: a positive integer, or null for "latest"
export function parseVersionParam(raw: string | null): number | null {
  if (!raw || !/^\d+$/.test(raw)) return null
  const n = Number(raw)
  return n >= 1 ? n : null
}
